import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';

import {
  currencyQuery as CurrencyQueryData,
  currencyQuery_currencies,
} from './types/currencyQuery';

export type Currency = Omit<currencyQuery_currencies, '__typename'>;

export const defaultCurrency = {
  id: 'USD',
  icon: 'UnitedStates',
  multiplier: 1,
  name: 'USD',
  symbol: '$',
};

export const currencyQuery = gql`
  query currencyQuery {
    currencies {
      id
      icon
      multiplier
      name
      symbol
    }
  }
`;

export const useCurrencies = () => {
  const queryResults = useQuery<CurrencyQueryData>(currencyQuery);

  return {
    error: queryResults.error
      ? 'There was an issue loading currencies. Please try again'
      : null,
    currencies: queryResults?.data?.currencies || [],
    onSelectCurrency: (currency: Currency) =>
      queryResults.client.writeData({
        data: { selectedCurrency: currency },
      }),
    isLoading: queryResults.loading,
  };
};
